"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeGotoIngredient = void 0;
const AbstractIngredient_1 = require("./AbstractIngredient");
const java_object_serialization_1 = require("java-object-serialization");
const SerializeReadHelper_1 = require("./SerializeReadHelper");
class TimeGotoIngredient extends AbstractIngredient_1.AbstractIngredient {
    constructor() {
        super(...arguments);
        this.timeSeconds = 0.0;
        this.andThen = null;
    }
    readObject(stream) {
        const reader = new SerializeReadHelper_1.SerializeReadHelper(stream);
        const version = reader.readStringObject();
        if (version !== "V1-20011108") {
            throw new Error("bad TimeGotoIngredient version");
        }
        this.timeSeconds = reader.readDouble();
        this.andThen = reader.readStringObject();
        if (!reader.isReadAndCheckCrcOk()) {
            throw new Error("TimeGotoIngredient data is corrupted");
        }
    }
}
exports.TimeGotoIngredient = TimeGotoIngredient;
java_object_serialization_1.ObjectInputStream.RegisterObjectClass(TimeGotoIngredient, "com.erostek.eroslink.TimeGotoIngredient", "688125513414001038");
